import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { StoreService } from '@seu-services';
import { SeuConfigTranslationObject } from '@seu-types';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'seuConfigTranslation',
  standalone: true,
})
export class SeuConfigTranslationPipe implements PipeTransform {
  constructor(private store: StoreService) {}

  public transform(value: string): string {
    const lang = 'de';

    const keyArray = value.split('.');
    let returnValue: string | null = keyArray[keyArray.length - 1];
    let translationObject = this.store.getConfig()?.translations[lang];

    keyArray.forEach((key: string) => {
      if (translationObject) {
        const translationValue = translationObject[key];
        if (translationValue) {
          if (typeof translationValue === 'object') {
            translationObject = translationValue as SeuConfigTranslationObject;
          } else if (typeof translationValue === 'string') {
            returnValue = translationValue;
          }
        } else if (translationValue === '') {
          returnValue = '';
        }
      }
    });

    return returnValue;
  }
}
